/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityApiModel } from './capabilityApiModel';
import { EmployeeStatusOverviewApiModel } from './employeeStatusOverviewApiModel';


export interface EmployeesReportApiModel { 
    date: string;
    url: string;
    employees: Array<EmployeeStatusOverviewApiModel>;
    capabilities: Array<CapabilityApiModel>;
}

